import React, { useState, FormEvent } from 'react';
import './LostPassword.scss';
import { BaseReact } from '../../base.model';
import Input from '../Forms/Input';
import { Link } from 'react-router-dom';
import Button from '../Forms/Button';
import sharedToasterSubject from '../../services/shared.toasterSubject';


interface LostPasswordProps extends BaseReact { }

const REST_BASE_URL = (process.env.REACT_APP_HTTP_URL || '').replace(/\/graphql\/?$/, '');

function RecoverPassword({ history, location }: LostPasswordProps) {
    const [email, setEmail] = useState('');
    const [instructionsSent, setInstructionsSent] = useState(false);

    const submitRecover = (e: FormEvent) => {
        e.preventDefault();
        fetch(`${REST_BASE_URL}/recoverpassword`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email }),
        })
            .then(async (response) => {
                // 429 is shown as-is: it reveals nothing about whether the email is registered.
                // Any other response (200 or otherwise) shows the same "sent" message regardless
                // of whether the email actually exists, so that path stays non-enumerating.
                if (response.status === 429) {
                    const data = await response.json().catch(() => ({} as { error?: string }));
                    sharedToasterSubject.next({
                        type: 'error',
                        message: data.error || 'Demasiados intentos, espera un momento e intenta de nuevo.',
                    });
                    return;
                }
                setInstructionsSent(true);
                setTimeout(() => {
                    history.push('/')
                }, 5000)
            })
            .catch((err) => {
                console.error('Error requesting password recovery: ', err);
                sharedToasterSubject.next({
                    type: 'error',
                    message: 'Error de red, intenta de nuevo.',
                });
            });
    }

    const _setEmail = (e: string) => {
        setEmail(e.toLowerCase().trim());
    }

    return (
        <div id="LostPassword">
            <form className="_loginForm" onSubmit={submitRecover}>
                <h3>Recuperar tu contraseña</h3>
                {
                    instructionsSent ?
                        <p>
                            Se envió la liga para recuperar tu contraseña por correo
                    </p>
                        :
                        <>
                            <Input type="text" label="Usuario / Email de tu cuenta" value={email} onChange={_setEmail} placeholder="Tu email u Seller Token" />
                            <Button primary={true} type="submit">
                                <span>Recuperar contraseña</span>
                            </Button>
                        </>
                }
                <div className="_toRegiser">
                    <Link to="/login">
                        <Button secondary={true} type="button">
                            <span>
                                Regresar! ya me acordé
                                </span>
                        </Button>
                    </Link>
                </div>
            </form>
        </div>
    )
}

export default RecoverPassword;